const stripTags = function (html){
    const regex = /(<([^>]+)>)/ig;
    if(html){
        return html.replace(regex, "");
    }
    return "";
};

export default stripTags;
